import '../styles/Footer.scss';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer">
      <p>Designed with Figma, built with React.js, and deployed with Vercel</p>
      <p className="copyright">&copy; {currentYear} Anna Duong. All Rights Reserved.</p>
    </div>
  )
}

export default Footer;